import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SGSInputMask, SGSInputMaskProps } from 'components';
import { useTranslation } from 'react-i18next';

type Props = SGSInputMaskProps & {
    mask: string;
};

const SGSFormInputMask: React.FC<Props> = ({ name, label, type, variant, mask, ...props }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();
    return (
        <Controller
            {...props}
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <SGSInputMask
                    {...field}
                    variant={variant}
                    disabled={props.disabled}
                    label={t(label as string)}
                    multiline={props.multiline}
                    minRows={props.multiline && 5}
                    type={type}
                    InputProps={props.InputProps}
                    InputLabelProps={props.InputLabelProps}
                    error={!!error}
                    helperText={error?.message ?? ''}
                    mask={mask}
                />
            )}
        />
    );
};

export default SGSFormInputMask;
